(function($, window, document, s, undefined) {

  var initReadMoreLink = function initReadMoreLink(characterCount) {
    var $originalDesc = s.$doc.find('.author-text');
    var originalDesc = '';
    var croppedDesc = '';
    var _charsLeft = characterCount;


    if (!$originalDesc) {
      return;
    }


    originalDesc = $originalDesc.html();

    if (originalDesc.length < characterCount) {
      return;
    }

    originalDesc += '<a class="read-more-toggle open" href="javascript:void(0)">Λιγότερα</a>';

    // Traverse the children in order to find the apppropriate tagName and
    // crop the text appropriately.
    $originalDesc.children().each(function (){
      var _tagName = this.tagName.toLowerCase();
      var _tagHtml = this.innerHTML;
      var _length = _tagHtml.length;

      croppedDesc += '<' + _tagName + '>';

      if (_length < _charsLeft) {
        croppedDesc += _tagHtml;
      } else {
        croppedDesc += _tagHtml.substr(0, _charsLeft).trim();
        croppedDesc += '... <a class="read-more-toggle" href="javascript:void(0)">Περισσότερα</a>';
      }

      croppedDesc += '</' + _tagName + '>';

      _charsLeft -=  _length;

      if (_charsLeft < 1) {
        return false;
      }
    });

    $originalDesc.html(croppedDesc);

    s.$doc.on('click', '.read-more-toggle', function() {
      var replacementDesc = $(this).hasClass('open') ? croppedDesc : originalDesc;

      $originalDesc
        .fadeOut(400, function (){
          $originalDesc
            .html(replacementDesc)
            .fadeIn(400);
        });
    });
  };

  var checkForReadMoreLink = function checkForReadMoreLink() {
    if (s.bodyId === 'body-author-detail') {
      initReadMoreLink(800);
    }
  };

  s.callOnReady(checkForReadMoreLink);

})(jQuery, this, this.document, window.s);
